module.exports = __webpack_public_path__ + "static/media/galdisa_blog_blog1.e1ec823e.jpg";